import { Model } from 'pinia-orm';
import { Uid, Attr, Num, BelongsTo } from 'pinia-orm/decorators';
import { Section } from 'src/modules/Section/models/Section';
import type { TermsOfTransition } from 'src/types/course/termsOfTransition';

export class CourseSection extends Model {
  static override entity = 'course_section';

  @Uid() declare id: number;

  @Attr(null) declare terms_of_transition: TermsOfTransition[] | null;
  @Num(null) declare course_id: number | null;
  @Num(null) declare order: number | null;

  @Num(null) declare section_id: number | null;
  @BelongsTo(() => Section, 'section_id')
  declare section: Section | null;
}
